import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';


class NavPublicMenu extends Component {

  constructor(props){
    
    super(props);

  }

  renderAgentName = (i) => {
    let label = '';
    
    if(this.props.agents && this.props.agents.length > 0 && this.props.agents[i]){
      const a = this.props.agents[i];
      label = a.first_name ? a.first_name: '' ;
      label += a.last_name ? ' ' + a.last_name : '';
      label += a.last_name_2 ? ' ' + a.last_name_2 : '';
    }
    
    return label;
  }

  render() {
    return (
      <Navbar id="main_nav" bg="dark" expand="lg" className="navbar-dark">
        
          {this.props.development && this.props.development.url_image &&
            <Navbar.Brand href="/">
              <img src={this.props.development.url_image} alt={this.props.development.name} height="60" />
            </Navbar.Brand>
          }
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          {
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              { this.props.agents && this.props.agents.length > 0 && this.props.selected_agent != null &&
                <NavDropdown title={this.renderAgentName(this.props.selected_agent)} id="basic-nav-dropdown">
                  <NavDropdown.Item onClick={this.props.logout} >Cambiar</NavDropdown.Item>
                </NavDropdown>
              }
            </Nav>
          </Navbar.Collapse>
          }
          
          {this.props.development && (this.props.development.email || this.props.development.phone) &&
            <Nav className="d-none d-lg-block d-xl-block d-xll-block justify-content-end">
              {this.props.development.phone &&
              <Navbar.Text className="nav-text">{this.props.development.phone}</Navbar.Text>
              }
              {this.props.development.email &&
              <Navbar.Text className="nav-text"><a href="{this.props.development.phone}">{this.props.development.email}</a></Navbar.Text>
              }
            </Nav>
          }
        
      </Navbar>
    );
  }

}

export default withRouter(NavPublicMenu);